// Importing Link component from react-router-dom to enable navigation between routes
import { Link } from 'react-router-dom';
// Importing the User type from the local types definition file for type safety
import type { User } from "../../../types";

// HeroSection component displays a personalized welcome message
// and a call-to-action for exploring courses.
interface HeroSectionProps {
  user: User; // The logged-in user object containing username and real_name
}
function HeroSection({ user }: HeroSectionProps) {
  return (
  <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-20 text-center">
    {/* Welcome message */}
    <h1 className="text-5xl font-extrabold tracking-tight">
      Welcome, {user.real_name || user.username}!
    </h1>
    {/* Motivational subtitle */}
    <p className="mt-4 text-xl text-gray-100 max-w-2xl mx-auto">
      Discover courses, track deadlines, and engage with your learning community.
    </p>
    {/* Call-to-action button */}
    <Link
      to="/courses"
      className="mt-8 inline-block px-8 py-3 bg-white text-blue-600 font-semibold rounded-lg shadow-md hover:shadow-lg hover:bg-gray-100 transition-all duration-300"
    >
      Explore Courses
    </Link>
  </div>
);

}
export default HeroSection;